export default "__VITE_ASSET__DmyOgd9G__"